export default {
  // Title
  shareCanvas: "Share Canvas",

  // Loading
  loading: "Loading...",

  // Share permission
  sharePermission: "Share Permission",
  viewOnly: "View Only",
  viewOnlyDescription: "No login required, accessible with password",
  copyable: "Copyable",
  copyableDescription:
    "Login required, users can copy the canvas, accessible with password",

  // Validity period
  validity: "Validity Period",
  pleaseSelect: "Please Select",
  oneDay: "1 day",
  threeDays: "3 days",
  sevenDays: "7 days",
  fourteenDays: "14 days",
  thirtyDays: "30 days",

  // Address masking
  addressMasking: "Address Masking",

  // Access password
  accessPassword: "Access Password",

  // Buttons
  copyLink: "Copy Link",

  // Messages
  copySuccess: "Copy successful",
};
